import ProgressMeetingDataSource from "data/dataSource/Admin/ProgressMeetingDataSource"
import { CreateNewProject } from "domain/model/ProjectSection"
import { Auth } from "domain/model/Auth"
export class ProgressMeetingRepositoryImpl implements ProgressMeetingRepositoryImpl {
  private dataSource: ProgressMeetingDataSource
  constructor(dataSource: ProgressMeetingDataSource) {
    this.dataSource = dataSource
  }
  async createProgressMeeting(auth: Auth, data: any): Promise<any> {
    return this.dataSource.createProgressMeeting(auth, data)
  }

  async getAllProgressMeetings(auth: Auth, data: any): Promise<any> {
    return this.dataSource.getAllProgressMeetings(auth, data)
  }

  async getUpcomingProgressMeetings(auth: Auth, data: any): Promise<any> {
    return this.dataSource.getUpcomingProgressMeetings(auth, data)
  }

  async deleteProgressMeeting(auth: Auth, data: any): Promise<any> {
    return this.dataSource.deleteProgressMeeting(auth, data)
  }

  async updateProgressMeeting(auth: Auth, data: any): Promise<any> {
    return this.dataSource.updateProgressMeeting(auth, data)
  }
  async getProgressMeetFeedback(auth: Auth, meeting_id: string): Promise<any> {
    return this.dataSource.getProgressMeetFeedback(auth, meeting_id)
  }
  async getMentorshipStats(auth: Auth, batches: string[], meetingDate: number): Promise<any> {
    return this.dataSource.getMentorshipStats(auth, batches, meetingDate)
  }
  async getClassAttendanceStats(auth: Auth, batches: string[], meetingDate: number): Promise<any> {
    return this.dataSource.getClassAttendanceStats(auth, batches, meetingDate)
  }
  async getExamStats(auth: Auth, batches: string[], meetingDate: number): Promise<any> {
    return this.dataSource.getExamStats(auth, batches, meetingDate)
  }
}
